export const FAQS = [
  {
    q: "Is this online mouse jiggler really undetectable?",
    a: "Yes. Because Jiggly is a standard webpage, it does not interact with your local file system or registry. To an IT department, this looks exactly the same as having a tab open that is playing a video.",
  },
  {
    q: "Will my screen turn off while the tool is running?",
    a: "No. When Background Mode is enabled, the tool utilizes your browser's power-management APIs to request a continuous wake state.",
  },
  {
    q: "Does this work on Mac, Windows, and Chromebooks?",
    a: "Absolutely. It works flawlessly on Chrome, Edge, Safari, and Firefox across macOS, Windows, ChromeOS, and Linux.",
  },
  {
    q: "Do I need to leave this tab open?",
    a: "You must keep the browser tab open, but you do not need to stay on it. By activating Background Mode, you can switch to other tabs or minimize the browser.",
  },
  {
    q: "Is it free to use?",
    a: "Yes. You can use Jiggly as a guest for one hour of active session time. After that, sign in with Google to continue using the core engine at no charge. Pro is optional.",
  },
  {
    q: "Does it keep Gmail and Google Workspace active too?",
    a: "Yes. Jiggly simulates browser-level activity, so any web app that watches for interaction — Gmail, Google Docs, Salesforce, Zendesk — keeps treating your session as active.",
  },
  {
    q: "Is my data private?",
    a: "The jiggler runs in your browser. Guest usage is saved in this browser to remember your one-hour allowance. Google sign-in stores your basic profile and a secure session; Jiggly does not receive your Google password. An anonymous total of session minutes is also counted.",
  },
  {
    q: "Could using it get me in trouble at work?",
    a: "Jiggly never bypasses security — it is simply an open web page. That said, always follow your employer's policies about availability while you are away.",
  },
];

export const PERSONAS = [
  {
    icon: "briefcase",
    title: "Remote Professionals",
    copy: "Keep Microsoft Teams, Slack, and Zoom statuses green while you step away for a coffee, read physical documents, or take a mental break.",
    tags: ["Teams", "Slack", "Zoom"],
    img: "/images/remote-professional.webp",
    alt: "Remote professional working on a laptop in a dark room",
  },
  {
    icon: "graduation",
    title: "Students & Learners",
    copy: "Prevent your screen from sleeping while reading long digital textbooks, watching un-interactable lecture videos, or waiting in exam queues.",
    tags: ["Study", "Lectures", "Exam queues"],
    img: "/images/student.webp",
    alt: "Student studying in a library at night",
  },
  {
    icon: "gamepad",
    title: "Gamers",
    copy: "Avoid getting kicked for inactivity from server queues or game lobbies while you wait for your friends to join the match.",
    tags: ["Queues", "Lobbies", "AFK"],
    img: "/images/gaming-setup.webp",
    alt: "Gaming setup glowing in a dark room",
  },
];

export const STEPS = [
  {
    n: "01",
    title: "Set your schedule",
    copy: "Use the built-in time picker to determine exactly when the session should end, aligning perfectly with your work hours.",
  },
  {
    n: "02",
    title: "Click start",
    copy: "The engine instantly initializes a zero-footprint browser session that communicates directly with your OS power management.",
  },
  {
    n: "03",
    title: "Enable background mode",
    copy: "Trigger the background engine, allowing you to switch to other tabs or minimize the browser while staying active.",
  },
];

export const COMPAT = [
  {
    icon: "message",
    title: "Communication Platforms",
    items: ["Microsoft Teams", "Slack", "Zoom", "Webex", "Google Meet", "Skype", "Discord", "Outlook"],
  },
  {
    icon: "monitor",
    title: "Operating Systems",
    items: ["Windows 11", "Windows 10", "macOS (Apple Silicon & Intel)", "ChromeOS", "Linux"],
  },
  {
    icon: "usb",
    title: "Hardware Alternatives",
    items: ["Physical USB mouse movers", "Mechanical jigglers", "Auto-clicker software"],
  },
];

export const COMPARE = {
  columns: ["Jiggly", "USB Jiggler", "Software (.exe)"],
  rows: [
    { feature: "Admin rights needed?", values: [true, true, false] },
    { feature: "IT detectable?", values: ["No — browser sandbox", "Yes — USB registry", "Yes — process list"] },
    { feature: "Cost", values: ["Free", "$15 – $30", "Free / Paid"] },
    { feature: "Installation required?", values: ["None", "Plug-in hardware", "Download & install"] },
  ],
};

export const CAPABILITIES = [
  {
    title: "Remote Work Apps",
    to: "/how-it-works",
    items: [
      "Keep Teams status green",
      "Prevent Slack 'Away' status",
      "Keep Zoom status active",
      "Stop Webex idle timeout",
      "Stay active on Google Meet",
    ],
  },
  {
    title: "Operating Systems",
    to: "/how-it-works",
    items: [
      "Windows 10 lock prevention",
      "Keep Windows 11 awake",
      "Prevent Mac sleep mode",
      "Stop macOS screen dimming",
      "Keep Chromebooks active",
    ],
  },
  {
    title: "Security & Compliance",
    to: "/faq",
    items: [
      "Undetectable IT bypass",
      "Safe USB alternative",
      "No installation required",
      "No admin rights required",
      "Corporate network bypass",
    ],
  },
];
